import { Keys } from "@mcleod/core";
import { DesignableObjectLogManager } from "../../logging/DesignableObjectLogManager";

const log = DesignableObjectLogManager.getLogger("components.LookupModelSearchStateManager");

export enum LookupModelState {
    START = "start",
    DISPLAYED = "displayed"
}

export class LookupModelSearchStateManager {
    private _lookupModelState: LookupModelState | KeyboardEvent;
    private _lookupModelSearchGeneration: number = 0;

    public prepareForSearch(): void {
        log.debug(this, "may set _lookupModelState; current value: %o  proposed value: %o", this._lookupModelState, LookupModelState.START);
        if (this.hasPendingLookupKeyboardEvent()) {
            return;
        }
        this._lookupModelState = LookupModelState.START;
    }

    public initiateNewLookupModelSearch(): number {
        this.invalidateLookupModelSearches();
        return this._lookupModelSearchGeneration;
    }

    public queuePendingLookupModelResolution(event: KeyboardEvent): boolean {
        if (event.key !== Keys.TAB || this._lookupModelState !== LookupModelState.START) {
            return false;
        }
        log.debug(this, "queuePendingLookupModelResolution; current state: %o  event: %o", this._lookupModelState, event);
        this._lookupModelState = event;
        return true;
    }

    public hasPendingLookupKeyboardEvent(): boolean {
        return this._lookupModelState instanceof KeyboardEvent;
    }

    public hasPendingLookupModelResolution(): boolean {
        return this.hasPendingLookupKeyboardEvent() && (this._lookupModelState as KeyboardEvent).key === Keys.TAB;
    }

    public getPendingLookupModelResolutionEvent(): KeyboardEvent {
        return this.hasPendingLookupModelResolution() ? this._lookupModelState as KeyboardEvent : null;
    }

    public markLookupModelSearchDisplayed(): boolean {
        if (this._lookupModelState !== LookupModelState.START) {
            return false;
        }
        this._lookupModelState = LookupModelState.DISPLAYED;
        return true;
    }

    public isLookupModelSearchDisplayed(): boolean {
        return this._lookupModelState === LookupModelState.DISPLAYED;
    }

    public clearLookupModelSearchState(): void {
        this._lookupModelState = null;
    }

    public clearLookupModelSearchStateIfNotPendingKeyboardEvent(): void {
        if (!this.hasPendingLookupKeyboardEvent()) {
            this.clearLookupModelSearchState();
        }
    }

    public resetOnFocusChange(): void {
        this.invalidateLookupModelSearches();
        this._lookupModelState = undefined;
    }

    public describeState(): LookupModelState | "pending-keyboard-event" | "idle" {
        return this.hasPendingLookupKeyboardEvent() ? "pending-keyboard-event" :
            this._lookupModelState as LookupModelState ?? "idle";
    }

    public invalidateLookupModelSearches(): void {
        this._lookupModelSearchGeneration++;
    }

    public hasCurrentLookupModelSearch(searchGeneration: number): boolean {
        return searchGeneration === this._lookupModelSearchGeneration;
    }
}
